import $ from 'jquery';
import { CountrySelectOptionDefinition } from './models/index';

window.__format_country_result_with_flag = function formatCountryResult(
  selectOptionDef: CountrySelectOptionDefinition,
) : string { 
  if (typeof selectOptionDef.children !== 'undefined') {
    return selectOptionDef.text;
  }

  const data = $(selectOptionDef.element).data();
  
  return `
    <img src="${data.flag}" alt="Flag of ${data.country}" />
    <br />
    {${data.country}}
    <div class="text-xxx-small imt-select-country-name">
      {${data.currency} ({${data.currencyCode})
    </div>
  `;
};

window.__format_country_select_with_flag = function formatCountrySelect(
  selectOptionDef: CountrySelectOptionDefinition,
) : string {
  const data = $(selectOptionDef.element).data();
  return `<img src="${data.flag}" alt="Flag of ${data.country}"/> ${data.currencyCode}`;
};
